import React from 'react';
import { Box, IconButton } from '@design-system/pc';
import styled from 'styled-components';
import useFloatingTopButton from './hooks/useFloatingTopButton';
import TrackingService from '@/services/tracking';

interface FloatingTopButtonProps {
  isShowTopButton: boolean;
  handleIsShowTopButton: (value: boolean) => void;
}

const FloatingTopButton = ({
  isShowTopButton,
  handleIsShowTopButton,
}: FloatingTopButtonProps) => {
  const { handleClickScrollTop } = useFloatingTopButton({
    handleIsShowTopButton,
  });

  return (
    <ScrollTopButtonWrapper
      isShowTopButton={isShowTopButton}
      width={52}
      height={52}
      position="absolute"
      right="8px"
      bottom="0"
      {...TrackingService.tagGTM('scroll_top_button')}
    >
      <ScrollTopButton onClick={handleClickScrollTop}>
        <IconButton size="xlg" variant="ic_arrow_top" />
      </ScrollTopButton>
    </ScrollTopButtonWrapper>
  );
};

export default FloatingTopButton;

const ScrollTopButtonWrapper = styled(Box)<{ isShowTopButton: boolean }>`
  transform: scale(${({ isShowTopButton }) => (isShowTopButton ? 1 : 0)});
  transition: transform 0.2s;
`;

const ScrollTopButton = styled(Box)`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.color_chip.white};
  border: 1px solid ${(props) => props.theme.colors.color_chip.gray[100]};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
